import React from 'react';
import { AuthGuard } from 'guards/auth-guard';

/* eslint-disable react/display-name */
export const withAuthGuard = (Component: any) => (props: any) => (
  <AuthGuard>
    <Component {...props} />
  </AuthGuard>
);
/* eslint-enable react/display-name */
